//import { Component, OnInit } from '@angular/core';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { MemoryStorageService } from 'src/app/services/memory-storage.service';

declare function loadRequiredFiles(a: string): any;

declare function generatechartservice(
  chartproperties: any,
  jsondata: any,
  dashboarddivid: string,
): any;

@Component({
  selector: 'app-chart-dashboard',
  templateUrl: './chart-dashboard.component.html',
  styleUrls: ['./chart-dashboard.component.css']
})
// export class ChartDashboardComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//   }

// }

export class ChartDashboardComponent implements OnInit {


  @Component({
    selector: 'app-chart_dashboard',
    templateUrl: './chart_dashboard.component.html',
    styleUrls: ['./chart_dashboard.component.css'],
  })

  jsondata: any = []
  jsondata1: any = []
  jsondata2: any = []
  jsondata3: any = []
  jsondata4: any = []
  jsondata5: any = []
  is_dataloaded: boolean = false;
  Project_id: number = 0;
  IsContractView: boolean = false;

  chartproperties: any = {
    "chartheight": 300,
    "chartwidth": 600,
    "charttype": "column",
    "charttitle": "Department-wise invoices status",
    //   "titlefontsize": "16px",
    //  "titlefontweight": "bold",
    // "Chartcolor":["#46A19D", "#0070B1", "#BED046", "#4D2F9E", "#998A00"],
    "Chartcolor": ["#fc0303", "#0394fc"],
    "measurments": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "PO"
        // "displayname": "po"
      },
      {
        "resulttype": "Alphanumeric",
        "alias_name": "Non PO"
        // "displayname": "non po"
      }
    ],
    "dimension_name": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "department",
      }
    ],
    "showytitle": true,
    "isdrilldown": false,
    "showxtitle": false,
    "isgrid": false,
    "xaxisfontsize": "12px",
    "chart_labely": [
      "Volume"
    ],
    "Isdatalabel": true,
    "datalabelfontsize": "12px"
  }

  chartproperties1: any = {
    "chartheight": 300,
    "chartwidth": 600,
    "charttype": "donut",
    "charttitle": "Queue-wise invoices status",
    // "Chartcolor":["#46A19D", "#0070B1", "#BED046", "#4D2F9E", "#998A00"],
    "Chartcolor": ["#fc0303", "#78F7A8", "#fc7b03", "#0394fc", "#02EDED", "#0C5E8D", "#F390D5", "#FB4185"],
    "measurments": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "count"
        //"displayname": "co"
      },

    ],
    "dimension_name": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "processmodule",
      }
    ],
    "showytitle": true,
    "isdrilldown": false,
    "showxtitle": false,
    "isgrid": false,
    "xaxisfontsize": "12px",
    "chart_labely": [
      "Volume"
    ],
    "Isdatalabel": true,
    "datalabelfontsize": "12px"
  }

  chartproperties2: any = {
    "chartheight": 300,
    "chartwidth": 600,
    "charttype": "area-spline",
    "charttitle": "Top 5 Vendor invoices status",
    // "Chartcolor":["#46A19D", "#0070B1", "#BED046", "#4D2F9E", "#998A00"],
    "Chartcolor": ["#fc0303", "#0394fc", "#fc7b03", "#0394fc"],
    "measurments": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "COMPLETED"
        // "displayname": "completed"
      },
      {
        "resulttype": "Alphanumeric",
        "alias_name": "PENDING"
        // "displayname": "pending"
      }
    ],
    "dimension_name": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "vendor",
      }
    ],
    "showytitle": true,
    "isdrilldown": false,
    "showxtitle": false,
    "isgrid": false,
    "xaxisfontsize": "12px",
    "chart_labely": [
      "Volume"
    ],
    "Isdatalabel": true,
    "datalabelfontsize": "12px"
  }

  chartproperties3 = {
    "chartheight": 300,
    "chartwidth": 600,
    "charttype": "stacked-bar",
    "charttitle": "Top 5 Vendor pending invoices status",
    // "Chartcolor":["#46A19D", "#0070B1", "#BED046", "#4D2F9E", "#998A00"],
    "Chartcolor": ["#fc0303", "#78F7A8", "#0394fc", "#fc7b03"],
    "measurement_name": ["COMPLETED", "PENDING", "APPROVAL", "QUERY"],
    "measurments": [{ "resulttype": 'numeric', "alias_name": 'indexing' }, { "resulttype": 'numeric', "alias_name": 'hold' }
      , { "resulttype": 'numeric', "alias_name": 'query' }, { "resulttype": 'numeric', "alias_name": 'approval' }],
    "dimension_name": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "vendor",
      }
    ],
    "showytitle": true,
    "isdrilldown": false,
    "showxtitle": false,
    "isgrid": false,
    "xaxisfontsize": "12px",
    "chart_labely": [
      "Volume"
    ],
    "Isdatalabel": true,
    "datalabelfontsize": "12px"
  }

  chartproperties4: any = {
    "chartheight": 300,
    "chartwidth": 600,
    "charttype": "column",
    "charttitle": "Document-wise invoices status",
    // "Chartcolor":["#46A19D", "#0070B1", "#BED046", "#4D2F9E", "#998A00"],
    "Chartcolor": ["#fc0303", "#78F7A8", "#fc7b03", "#0394fc"],
    "measurments": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "COMPLETED"
        //"displayname": "comp"
      },
      {
        "resulttype": "Alphanumeric",
        "alias_name": "PENDING"
        // "displayname": "pend"
      }
    ],
    "dimension_name": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "document",
      }
    ],
    "showytitle": true,
    "isdrilldown": false,
    "showxtitle": false,
    "isgrid": false,
    "xaxisfontsize": "12px",
    "chart_labely": [
      "Volume"
    ],
    "Isdatalabel": true,
    "datalabelfontsize": "12px"
  }


  chartproperties5: any = {
    "chartheight": 300,
    "chartwidth": 600,
    "charttype": "pie",
    "charttitle": "Payable Aging invoices",
    // "Chartcolor":["#46A19D", "#0070B1", "#BED046", "#4D2F9E", "#998A00"],
    "Chartcolor": ["#fc0303", "#78F7A8", "#0394fc", "#fc7b03"],
    "measurments": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "PENDING INVOICE"
        // "displayname": "pending"
      }
    ],
    "dimension_name": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "PayableAging",
      }
    ],
    "showytitle": true,
    "isdrilldown": false,
    "showxtitle": false,
    "isgrid": false,
    "xaxisfontsize": "12px",
    "chart_labely": [
      "Volume"
    ],
    "Isdatalabel": true,
    "datalabelfontsize": "12px"
  }


  chartproperties_C: any = {
    "chartheight": 300,
    "chartwidth": 600,
    "charttype": "column",
    "charttitle": "Department-wise invoices status",
    //   "titlefontsize": "16px",
    //  "titlefontweight": "bold",
    // "Chartcolor":["#46A19D", "#0070B1", "#BED046", "#4D2F9E", "#998A00"],
    "Chartcolor": ["#fc0303", "#0394fc"],
    "measurments": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "BC"
        // "displayname": "po"
      },
      {
        "resulttype": "Alphanumeric",
        "alias_name": "SVC"
        // "displayname": "non po"
      }
    ],
    "dimension_name": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "department",
      }
    ],
    "showytitle": true,
    "isdrilldown": false,
    "showxtitle": false,
    "isgrid": false,
    "xaxisfontsize": "12px",
    "chart_labely": [
      "Volume"
    ],
    "Isdatalabel": true,
    "datalabelfontsize": "12px"
  }

  chartproperties_C1: any = {
    "chartheight": 300,
    "chartwidth": 600,
    "charttype": "donut",
    "charttitle": "Queue-wise invoices status",
    // "Chartcolor":["#46A19D", "#0070B1", "#BED046", "#4D2F9E", "#998A00"],
    "Chartcolor": ["#fc0303", "#78F7A8", "#fc7b03", "#0394fc", "#02EDED", "#0C5E8D", "#F390D5", "#FB4185"],
    "measurments": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "count"
        //"displayname": "co"
      },

    ],
    "dimension_name": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "processmodule",
      }
    ],
    "showytitle": true,
    "isdrilldown": false,
    "showxtitle": false,
    "isgrid": false,
    "xaxisfontsize": "12px",
    "chart_labely": [
      "Volume"
    ],
    "Isdatalabel": true,
    "datalabelfontsize": "12px"
  }

  chartproperties_C2: any = {
    "chartheight": 300,
    "chartwidth": 600,
    "charttype": "area-spline",
    "charttitle": "Top 5 Vendor invoices status",
    // "Chartcolor":["#46A19D", "#0070B1", "#BED046", "#4D2F9E", "#998A00"],
    "Chartcolor": ["#fc0303", "#0394fc", "#fc7b03", "#0394fc"],
    "measurments": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "COMPLETED"
        // "displayname": "completed"
      },
      {
        "resulttype": "Alphanumeric",
        "alias_name": "PENDING"
        // "displayname": "pending"
      }
    ],
    "dimension_name": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "Contract Party1 Name",
      }
    ],
    "showytitle": true,
    "isdrilldown": false,
    "showxtitle": false,
    "isgrid": false,
    "xaxisfontsize": "12px",
    "chart_labely": [
      "Volume"
    ],
    "Isdatalabel": true,
    "datalabelfontsize": "12px"
  }

  chartproperties_C3 = {
    "chartheight": 300,
    "chartwidth": 600,
    "charttype": "stacked-bar",
    "charttitle": "Top 5 Vendor pending invoices status",
    // "Chartcolor":["#46A19D", "#0070B1", "#BED046", "#4D2F9E", "#998A00"],
    "Chartcolor": ["#fc0303", "#78F7A8", "#0394fc", "#fc7b03"],
    "measurement_name": ["COMPLETED", "PENDING", "APPROVAL", "QUERY"],
    "measurments": [{ "resulttype": 'numeric', "alias_name": 'indexing' }, { "resulttype": 'numeric', "alias_name": 'hold' }
      , { "resulttype": 'numeric', "alias_name": 'query' }, { "resulttype": 'numeric', "alias_name": 'approval' }],
    "dimension_name": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "vendor",
      }
    ],
    "showytitle": true,
    "isdrilldown": false,
    "showxtitle": false,
    "isgrid": false,
    "xaxisfontsize": "12px",
    "chart_labely": [
      "Volume"
    ],
    "Isdatalabel": true,
    "datalabelfontsize": "12px"
  }

  chartproperties_C4: any = {
    "chartheight": 300,
    "chartwidth": 600,
    "charttype": "column",
    "charttitle": "Document-wise invoices status",
    // "Chartcolor":["#46A19D", "#0070B1", "#BED046", "#4D2F9E", "#998A00"],
    "Chartcolor": ["#fc0303", "#78F7A8", "#fc7b03", "#0394fc"],
    "measurments": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "COMPLETED"
        //"displayname": "comp"
      },
      {
        "resulttype": "Alphanumeric",
        "alias_name": "PENDING"
        // "displayname": "pend"
      }
    ],
    "dimension_name": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "document",
      }
    ],
    "showytitle": true,
    "isdrilldown": false,
    "showxtitle": false,
    "isgrid": false,
    "xaxisfontsize": "12px",
    "chart_labely": [
      "Volume"
    ],
    "Isdatalabel": true,
    "datalabelfontsize": "12px"
  }


  chartproperties_C5: any = {
    "chartheight": 300,
    "chartwidth": 600,
    "charttype": "pie",
    "charttitle": "Payable Aging invoices",
    // "Chartcolor":["#46A19D", "#0070B1", "#BED046", "#4D2F9E", "#998A00"],
    "Chartcolor": ["#fc0303", "#78F7A8", "#0394fc", "#fc7b03"],
    "measurments": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "PENDING INVOICE"
        // "displayname": "pending"
      }
    ],
    "dimension_name": [
      {
        "resulttype": "Alphanumeric",
        "alias_name": "PayableAging",
      }
    ],
    "showytitle": true,
    "isdrilldown": false,
    "showxtitle": false,
    "isgrid": false,
    "xaxisfontsize": "12px",
    "chart_labely": [
      "Volume"
    ],
    "Isdatalabel": true,
    "datalabelfontsize": "12px"
  }





  lstScript = [];
  @Output() selectRecord: EventEmitter<any> = new EventEmitter();
  @Output() closeModal: EventEmitter<void> = new EventEmitter();

  constructor(private elementRef: ElementRef, private dataService: DataService, private commonService: CommonService, private memorystore: MemoryStorageService) {
    this.lstScript = [
      // {
      //   sriptName: 'jquery',
      //   //<script type="text/javascript" src= https://code.jquery.com/jquery-3.7.1.min.js></script>
      //   //src: 'https://code.jquery.com/jquery-3.7.1.min.js',
      //  src: 'http://10.251.230.132:8047/assets/js/generateservice.js',

      // },

      {
        sriptName: 'generateservice',
        //<script type="text/javascript" src= https://code.jquery.com/jquery-3.7.1.min.js></script>
        //src= 'https://code.jquery.com/jquery-3.7.1.min.js',
        //src: 'http://10.251.230.132:8047/assets/js/generateservice.js',
        //src: 'https://10.251.230.132:8061/assets/js/ChartService.js',
        src: 'https://10.251.230.132:8035/assets/js/ChartService.js',

      },
      {
        sriptName: 'multiselect1',
        src: 'https://10.251.230.132:8035/assets/js/jquery.multiselect.js',
      },
      {
        sriptName: 'multiselect2',
        src: 'https://10.251.230.132:8035/assets/js/jquery.query.min.js',
      },
      {
        sriptName: 'multiselect3',
        src: 'https://10.251.230.132:8035/assets/js/jquery.c3chart.js',
      },
      {
        sriptName: 'multiselect4',
        src: 'https://10.251.230.132:8035/assets/js/jquery.c3.js',
      },
      {
        sriptName: 'multiselect5',
        src: 'https://10.251.230.132:8035/assets/js/chartcollection.js',
      },
      {
        sriptName: 'multiselect6',
        src: 'https://10.251.230.132:8035/assets/js/d3.v5.js',
      },
      {
        sriptName: 'multiselect7',
        src: 'https://10.251.230.132:8035/assets/js/d3.funnel.min.js',
      },
      {
        sriptName: 'multiselect8',
        src: 'https://10.251.230.132:8035/assets/js/jquery.multiselect.js',
      }


    ];
  }

  async ngOnInit(): Promise<void> {
    this.Project_id = this.commonService.selectedProject;
    if (this.Project_id == 26)
      this.IsContractView = true;
    await this.get360chartjson();
  }
  loadJS(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.nonce = "cd90d3070658eb370a6e152dc25dc04f";
    if (self === top) {
      var antiClickjack = document.getElementById("antiClickjack");
      antiClickjack.parentNode.removeChild(antiClickjack);
    } else {
      //top.location = self.location;
    }
    this.elementRef.nativeElement.appendChild(script);

    return script;
  }
  loadDashboardOrReport() {
    //this.commonService.showHideLoader(true);
    debugger;
    this.lstScript.forEach((s) => {
      this.loadJS(s.src).onload = (ev) => {
        //debugger;
        // loadRequiredFiles('10.251.230.132:8047');
        //loadRequiredFiles('10.251.230.132:8061');
        loadRequiredFiles('10.251.230.132:8061');

      };
    });
    if (this.IsContractView) {
      generatechartservice(this.chartproperties_C, this.jsondata, 'Chartdiv1');
      generatechartservice(this.chartproperties_C1, this.jsondata1, 'Chartdiv2');
      generatechartservice(this.chartproperties_C2, this.jsondata2, 'Chartdiv3');
      //generatechartservice(this.chartproperties_C3, this.jsondata3, 'Chartdiv4');
      generatechartservice(this.chartproperties_C4, this.jsondata4, 'Chartdiv5');
      //generatechartservice(this.chartproperties_C5, this.jsondata5, 'Chartdiv6');
    }
    else {
      generatechartservice(this.chartproperties, this.jsondata, 'Chartdiv1');
      generatechartservice(this.chartproperties1, this.jsondata1, 'Chartdiv2');
      generatechartservice(this.chartproperties2, this.jsondata2, 'Chartdiv3');
      generatechartservice(this.chartproperties3, this.jsondata3, 'Chartdiv4');
      generatechartservice(this.chartproperties4, this.jsondata4, 'Chartdiv5');
      generatechartservice(this.chartproperties5, this.jsondata5, 'Chartdiv6');
    }

    //this.commonService.showHideLoader(false);
    this.is_dataloaded = true;
  }

  get360chartjson() {

    //let params = new HttpParams();
    let reqData = {};
    reqData = {
      project_id: this.commonService.selectedProject,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
    }
    this.dataService.getData('get-chart-data', reqData).subscribe(res => {
      if (res != null && res.success == true) {
        //this.approvalQueryCount = res.data[0].count;
        this.jsondata = res.data.Table;
        this.jsondata1 = res.data.Table1;
        this.jsondata2 = res.data.Table2;
        this.jsondata3 = res.data.Table3;
        this.jsondata4 = res.data.Table4;
        this.jsondata5 = res.data.Table5;
        this.loadDashboardOrReport()
        // this.loadDashboardOrReport1()
      }
    });
  }



  dismissModal() {
    this.closeModal.emit();
  }
}